import script from "./TwitterTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./TwitterTimeline.vue?vue&type=script&setup=true&lang=js"

import "./TwitterTimeline.vue?vue&type=style&index=0&id=207b9b23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207b9b23"]])

export default __exports__